import { searchMedia } from '@/request/aiClip';
import { ref, onUnmounted, watch, nextTick } from 'vue';
import { useMainStore } from '@/pinia';
interface UserInfo {
  teamId?: string;
}
export const AUTHTYPELIST = [
  {
    value: '2',
    label: '团队',
  },
  {
    value: '3',
    label: '官方',
  },
];

export const MEDIATYPELIST = [
  {
    label: '视频',
    value: 1,
    settings: {
      screen: [
        { label: '横屏', value: '横屏' },
        { label: '竖屏', value: '竖屏' },
      ],
    },
  },
  {
    label: '文字',
    value: 2,
  },
  {
    label: '背景',
    value: 3,
    settings: {
      screen: [
        { label: '横屏', value: '横屏' },
        { label: '竖屏', value: '竖屏' },
      ],
    },
  },
  {
    label: '音频',
    value: 4,
  },
  {
    label: '装饰',
    value: 5,
  },
];

export function useMediaList() {
  const store = useMainStore();
  const userInfo = store.userInfo as UserInfo;
  // 请求参数
  const queryParams = ref<any>({
    pageIndex: 1,
    pageSize: 200,
    orgId: userInfo.teamId || '',
  });
  // 列表
  const mediaList = ref<any>([]);
  // 总数量
  const total = ref<any>(0);
  // 是否正在加载
  const loading = ref<any>(false);

  // 获取媒体列表
  const getMediaList = async () => {
    if (loading.value) return;
    loading.value = true;

    try {
      const { data } = await searchMedia(queryParams.value);
      let { list, total } = data.data;
      if (queryParams.value.pageIndex === 1) {
        mediaList.value = list;
      } else {
        mediaList.value = [...mediaList.value, ...list];
      }
      total.value = total;
    } catch (error) {
    } finally {
      loading.value = false;
    }
  };

  // 滚动到底部加载更多
  const loadMore = async () => {
    if (loading.value || mediaList.value.length >= total.value) return;
    queryParams.value.pageIndex += 1;
    await getMediaList();
  };

  // 重置然后调用
  const resetMediaList = () => {
    queryParams.value.pageIndex = 1;
    queryParams.value.pageSize = 200;
    getMediaList();
  };
  return {
    queryParams,
    mediaList,
    total,
    loadMore,
    getMediaList,
    resetMediaList,
  };
}
